module.exports = __webpack_public_path__ + "img/screen-2.03e08e48.jpg";